import { Button, Drawer, DrawerBody, DrawerFooter, DrawerHeader, Link, LoadingButton, TextField, Typography, } from '@one-thd/sui-atomic-components';
import { Orders } from '@one-thd/sui-icons';
import React, { useEffect, useState } from 'react';
import { GetOrderDetailsCSV } from '../../hooks/order-details-hooks/order-details-page-header-hooks';
import { pushEventInfo } from '../../utils/analytics';
import { getSvocId } from '../../utils/user';
import { useCommonContext } from '../../hooks/useContexts';
var exportClick = function (orderDetailsData, setLoading, setOpen, fileName, setAlertState, timezone) {
    var _a;
    pushEventInfo({
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: 'my account settings' },
        myAccount: { settings: 'purchase details: export' },
    });
    var isOnlineFlag = (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderOrigin) === 'Online';
    var exportRequest;
    if (isOnlineFlag) {
        exportRequest = {
            orderDetailsRequest: {
                customerAccountId: getSvocId() || '',
                exportType: 'csv',
                fileName: fileName,
                orderNumber: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
                searchType: 'online',
                timezone: timezone,
            },
        };
    }
    else if (((_a = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber) === null || _a === void 0 ? void 0 : _a[0]) === 'H') {
        exportRequest = {
            orderDetailsRequest: {
                customerAccountId: getSvocId() || '',
                exportType: 'csv',
                fileName: fileName,
                orderNumber: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
                registerNumber: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.registerNumber,
                salesDate: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.salesDate,
                searchType: 'instore',
                storeNumber: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.storeNumber,
                transactionId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.transactionId,
                timezone: timezone,
            },
        };
    }
    else {
        exportRequest = {
            orderDetailsRequest: {
                customerAccountId: getSvocId() || '',
                exportType: 'csv',
                fileName: fileName,
                registerNumber: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.registerNumber,
                salesDate: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.salesDate,
                searchType: 'instore',
                storeNumber: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.storeNumber,
                transactionId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.transactionId,
                timezone: timezone,
            },
        };
    }
    GetOrderDetailsCSV(exportRequest, isOnlineFlag ? 'online' : 'instore', setLoading, setOpen, setAlertState);
};
var generateDefaultFileName = function () {
    var _a, _b;
    var dateTime = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    }).format(new Date());
    var _c = (dateTime || '').split('at'), date = _c[0], time = _c[1];
    var formattedDate = (_a = date === null || date === void 0 ? void 0 : date.slice(0, -1)) === null || _a === void 0 ? void 0 : _a.replace(/[\s,]+/g, '-');
    var formattedTime = (_b = time === null || time === void 0 ? void 0 : time.slice(1)) === null || _b === void 0 ? void 0 : _b.replace(' ', '-').replace(':', '-');
    return "Purchase_History_".concat(formattedDate, "_").concat(formattedTime, ".csv");
};
var ExportOrderDetailsDrawer = function (_a) {
    var open = _a.open, setOpen = _a.setOpen, orderDetailsData = _a.orderDetailsData, setAlertState = _a.setAlertState;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(generateDefaultFileName()), fileName = _c[0], setFileName = _c[1];
    var timezone = useCommonContext().timezone;
    useEffect(function () {
        setFileName(generateDefaultFileName());
    }, [open]);
    return (React.createElement(Drawer, { open: open, onClose: function () { return setOpen(false); }, position: "right", style: { zIndex: 2000000009 } },
        React.createElement(DrawerHeader, { onClose: function () { return setOpen(false); }, title: "Export Order Details" }),
        React.createElement(DrawerBody, null,
            React.createElement("div", { className: "sui-pb-2" },
                React.createElement(Typography, { variant: "body-base" }, "Data will be exported as a csv file.")),
            React.createElement(TextField, { id: "export-order-details-csv", label: "Filename", value: fileName, onChange: function (event) {
                    setFileName(event.target.value);
                }, fullWidth: true })),
        React.createElement(DrawerFooter, { className: "card-fix sui-p-[16px]" },
            React.createElement("div", { className: "sui-flex sui-flex-col sui-w-full sui-gap-[16px]" },
                React.createElement(LoadingButton, { variant: "primary", loading: loading, onClick: function () {
                        return exportClick(orderDetailsData, setLoading, setOpen, fileName, setAlertState, timezone);
                    } }, "Export"),
                React.createElement(Button, { variant: "secondary", onClick: function () { return setOpen(false); } }, "Cancel")))));
};
export var ExportButton = function (_a) {
    var orderDetailsData = _a.orderDetailsData, setAlertState = _a.setAlertState, layout = _a.layout;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var checkIfAnyItemIsCanceled = function () {
        var _a;
        var isCanceled = [];
        (_a = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.fulfillmentGroups) === null || _a === void 0 ? void 0 : _a.forEach(function (fGroup) {
            var _a;
            var resp = (_a = fGroup === null || fGroup === void 0 ? void 0 : fGroup.lineItems) === null || _a === void 0 ? void 0 : _a.find(function (item) { var _a; return ['Canceled', 'Cancelled'].includes((_a = item === null || item === void 0 ? void 0 : item.statusDescription) !== null && _a !== void 0 ? _a : ''); });
            if (resp) {
                isCanceled.push(resp);
            }
        });
        if (isCanceled.length) {
            return false;
        }
        return true;
    };
    if (layout === 'table') {
        return (React.createElement(React.Fragment, null,
            React.createElement(Link, { variant: "body-sm", underline: "none", onClick: function () {
                    setOpen(true);
                } }, "Export"),
            React.createElement(ExportOrderDetailsDrawer, { open: open, setOpen: setOpen, orderDetailsData: orderDetailsData, setAlertState: setAlertState })));
    }
    if (checkIfAnyItemIsCanceled()) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Button, { onClick: function () {
                    setOpen(true);
                }, variant: "ghost", startIcon: Orders }, "Export"),
            React.createElement(ExportOrderDetailsDrawer, { open: open, setOpen: setOpen, orderDetailsData: orderDetailsData, setAlertState: setAlertState })));
    }
    return null;
};
